import { graphql } from "lib/generated/app-service-gql";
import { ContactsCreditSpendByUserQuery } from "lib/generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../useGraphQlClient";
import { REACT_QUERY_OPTIONS_NEVER_REFETCH } from "../utils";

const contactsCreditSpendByUserQuery = graphql(`
  query contactsCreditSpendByUser {
    contactsCreditSpendByUser {
      users {
        userGuid
        firstName
        lastName
        email
        creditsUsed
      }
    }
  }
`);

/** One spender's whole-window total. `userGuid` is absent for spend with no recorded user. */
export type ContactsCreditUsageUser =
  ContactsCreditSpendByUserQuery["contactsCreditSpendByUser"]["users"][number];

export type ContactsCreditSpendByUser = {
  /** Totals over the last 12 months, biggest spender first. Only users who spent anything appear. */
  users: ContactsCreditUsageUser[];
  isLoading: boolean;
  isError: boolean;
};

/**
 * Who in the company spent contact credits over the last 12 months.
 *
 * Company-admin only server-side — it names colleagues and exposes their emails — so callers must
 * mount this only for an admin, or the request comes back as a permission error.
 */
export function useContactsCreditSpendByUser(): ContactsCreditSpendByUser {
  const { data, isError, isLoading } = useGraphQlQuery(
    ["contactsCreditSpendByUser"],
    contactsCreditSpendByUserQuery,
    [undefined],
    REACT_QUERY_OPTIONS_NEVER_REFETCH,
  );

  return {
    users: data?.contactsCreditSpendByUser?.users ?? [],
    isLoading,
    isError,
  };
}
